import { mui, React, ui } from '_core';

import Swagger from '_components/swagger';

type ApiDetailsProps = {
  label: string;
  url: string;
};

const ApiDetails = ({ label, url }: ApiDetailsProps) => {
  const [loading, setLoading] = React.useState(true);

  return (
    <mui.core.Box
      sx={{
        marginTop: '1rem',
        '& .info': {
          display: 'none',
        },
      }}
    >
      <mui.core.Typography variant="h5" style={{ marginLeft: '1rem' }}>
        {label}
      </mui.core.Typography>
      {loading && <ui.CenteredLoader top="10vh" />}
      <Swagger url={url} onComplete={() => setLoading(false)} />
    </mui.core.Box>
  );
};

export default ApiDetails;
